import React, { useState, useEffect } from 'react'
import { Form, Row, Col, Spinner } from 'react-bootstrap'
import MainData from '../Form/FormParts/MainData'
import JobFunctions from '../Form/FormParts/JobFunctions'
import AssetDocuments from '../Form/FormParts/AssetDocuments'
import AssetActivationSwitch from '../Form/FormParts/AssetActivationSwitch'
import { useAssetDataState } from '../../../stores/AssetDataProvider'
import { useAssetTypesState } from '../../../stores/Configuration/AssetTypesProvider'
import { useTranslation } from 'react-i18next'
import useMountEffect from '../../../utils/hooks/useMountEffect';
import styled from 'styled-components'
const StyledWrapper = styled.div`
  .form-label {
    white-space: nowrap;
  }
`
const EditContentArea = () => {
  const {
    formErrors,
    mainData,
    setMainDataByKey,
    resetErrorByFormKey,
    activities,
    setActivitiesByKey,
    loadedAssetData,
    loadingActivities,
    selectableAvtivities,
  } = useAssetDataState()
  const { assetTypes, getAssetTypes } = useAssetTypesState()
  const { t } = useTranslation()
  const [fieldConfiguration, setFieldConfiguration] = useState(null)
  useMountEffect(() => {
    getAssetTypes()
  })
  useEffect(() => {
    let found = assetTypes.find(item => item.id === mainData.type.id);
    if (found) {
      setFieldConfiguration(found.fieldConfiguration)
    }
  }, [assetTypes, mainData.type.id])
  return (
    <Form>
      <AssetActivationSwitch />
      {
        //assetData must load first. because arraySelect might change stuff before assetData resets it again
        (!loadedAssetData || !fieldConfiguration)
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <h2 className="h1">{t('assetFormMainData:assetForm')}</h2>
            <StyledWrapper>
              <Row>
                <Col sm="6" >
                  <Form.Group className="mb-3">
                    <Form.Label>{t('assetFormMainData:type')}</Form.Label>
                    <Form.Control type="text" name="assetType" value={mainData.type.displayName} disabled={true} />
                  </Form.Group >
                </Col>
                {!!mainData.group?.displayName &&
                  <Col sm="6" >
                    <Form.Group className="mb-3">
                      <Form.Label>{t('assetFormMainData:group')}</Form.Label>
                      <Form.Control type="text" name="assetGroup" value={mainData.group.displayName} disabled={true} />
                    </Form.Group >
                  </Col>
                }
              </Row>
            </StyledWrapper>
            <MainData mainData={mainData} setMainDataByKey={setMainDataByKey} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} configuration={fieldConfiguration} />
            {!loadingActivities && selectableAvtivities && selectableAvtivities.length > 0 &&
              <JobFunctions selectableAvtivities={selectableAvtivities} activities={activities} setActivitiesByKey={setActivitiesByKey} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            }
            <AssetDocuments objectId={mainData.id} collapsible={true} />
          </>
      }
    </Form>)
}

export default EditContentArea
